import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    CarouselItemDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 0,
        minWidth: 0
    }
});

export const useStyles = ({
    orientation,
    isMeasured,
    itemSize,
    perView
}: CarouselItemDynamicStyleType) => {
    const styles = {
        container: {} as Mutable<ViewStyle>
    };

    if(orientation === "vertical") {
        styles.container.height = isMeasured ? itemSize : undefined;

        return styles;
    }

    styles.container.width = isMeasured ? itemSize : `${100 / perView}%`;

    return styles;
};
export default stylesheet;
